module.exports = __webpack_public_path__ + "static/media/result2.539fc3ef.png";